import { render, staticRenderFns } from "./InsStu.vue?vue&type=template&id=0c8027e7&scoped=true&"
import script from "./InsStu.vue?vue&type=script&lang=js&"
export * from "./InsStu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8027e7",
  null
  
)

export default component.exports